module.exports = __webpack_public_path__ + "img/animeriq-0.1.3.3f6da4e5.png";